import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MainRouter from './MainRouter';
import theme from './theme/muiTheme';

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  </ThemeProvider>
)

export default App;
